import React from 'react'
import {
  AccordionItem as ChakraAccordionItem,
  AccordionItemProps,
} from '@chakra-ui/react'

export const AccordionItem: React.FC<
  Pick<AccordionItemProps, 'as' | 'sx' | 'children'>
> = props => <ChakraAccordionItem {...props} />
